import { maxWidth } from '@creatic/reactic-styles';
import styled from 'styled-components';

export const StyledPanel = styled.div`
  position: fixed;
  right: ${({ theme }) => theme.metric.offset};
  bottom: ${({ theme }) => theme.metric.offset};
  z-index: ${({ theme }) => theme.zIndex.widget};
  display: flex;
  flex-direction: column;
  width: ${({ theme }) => theme.metric.panelWidth};
  height: ${({ theme }) => theme.metric.panelHeight};
  max-height: ${({ theme }) => `calc(100vh - 2 * ${theme.metric.offset})`};
  overflow: hidden;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey88};
  border-radius: 18px;
  box-shadow: ${({ theme }) => theme.shadow.panel};

  @media ${maxWidth.tablet} {
    inset: 0;
    width: 100%;
    height: 100%;
    max-height: none;
    border: none;
    border-radius: 0;
  }
`;
